import api from "@/services/apiClient";
import type { SuppressAlertData } from "../types/alertsSuppression.types";
export const alertsSuppressionService = {
  GetSuppressedAlerts: (timeZone: string): Promise<SuppressAlertData[]> =>
    api
      .get(
        `Alerts/GetSuppressedAlertsList?timeZone=${encodeURIComponent(timeZone)}`,
      )
      .then((res) => res.data),
  SuppressAlert: (payload: SuppressAlertData): Promise<boolean> =>
    api.post("Alerts/SuppressAlert", payload).then((res) => res.data),
  GetAlertNamesByProduct: (productName: string): Promise<string[]> =>
    api
      .get(
        `Alerts/GetAlertNamesByProduct?productName=${encodeURIComponent(productName)}`,
      )
      .then((res) => res.data),
  GetRootCausesByAlert: (alertName: string): Promise<string[]> =>
    api
      .get(
        `Alerts/GetRootCausesByAlert?alertName=${encodeURIComponent(alertName)}`,
      )
      .then((res) => res.data),
};
